import React, { useState, useEffect } from 'react';
import { Menu } from 'semantic-ui-react';

const ProductMenu = (props) => {
  const [selectedItem, setSelectedItem] = useState('');

  const { categories, onMenuChange, query } = props;

  const handleSelectedMenu = (event, target) => {
    setSelectedItem(target.name);
    onMenuChange(target.name);
  };

  useEffect(() => {
    if (query?.category) {
      setSelectedItem(`category.name=${query.category}`);
    }
  }, [query]);

  return (
    <Menu vertical>
      {
        categories.map((category, i) => {
          const categoryFilter = `category.name=${category.name}`;
          return (
            <div key={i}>
              <Menu.Item
                name={categoryFilter}
                active={selectedItem === categoryFilter}
                onClick={handleSelectedMenu}
                style={{fontSize: '1.2em'}}
              >
                {category.name}
              </Menu.Item>
              <Menu.Item>
                <Menu.Menu>
                {
                  category.subcategories.map((subcategory, j) => {
                    const subcategoryFilter = `category.name=${category.name}&subcategory.name=${subcategory.name}`;
                    return (
                      <Menu.Item
                        name={subcategoryFilter}
                        active={selectedItem === subcategoryFilter}
                        onClick={handleSelectedMenu}
                        style={{fontSize: '1.1em'}}
                        key={j}
                      >
                        {subcategory.name}
                      </Menu.Item>
                    );
                  })
                }
                </Menu.Menu>
              </Menu.Item>
            </div>
          );
        })
      }
    </Menu>
  );
};

export default ProductMenu;